/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { PERMISSIONS_ORG, PERMISSIONS_TENANT } from '../../../constants/main';

/**
 * Checks if a user has editor or admin access in a certain organization or bot.
 *
 * @param {orgId} String The current organization id.
 * @param {orgRoles} Object The roles of the user in the organization.
 * @param {tenantId} String The current bot id.
 * @param {tenantRoles} Object The roles of the user in that bot.
 * @param {adminOnly} Boolean Whether to include editor access or not.
 *
 * @returns {Boolean} True if the user is an admin (org or bot wide).
 */
const userHasEditAccess = (orgId, orgRoles, tenantId, tenantRoles, adminOnly = false) => {
  if (orgId in orgRoles && orgRoles[orgId]) {
    if (orgRoles[orgId].includes(PERMISSIONS_ORG.ADMIN) || (!adminOnly && orgRoles[orgId].includes(PERMISSIONS_ORG.EDITOR))) {
      return true;
    }
  }

  if (orgId in tenantRoles && tenantRoles[orgId][tenantId]) {
    if (tenantRoles[orgId][tenantId].includes(PERMISSIONS_TENANT.ADMIN) || (!adminOnly && tenantRoles[orgId][tenantId].includes(PERMISSIONS_TENANT.EDITOR))) {
      return true;
    }
  }
  return false;
};

export default userHasEditAccess;

